<!--
 * @Descripttion: 图片查重预览
 * @Date: 2025-09-01 13:58:47
-->
<template>
  <div class="repeat-pickure">
    <xrk-table
      ref="xrkTableRef"
      :getListAjax="getListAjax"
      :searchConfig="searchConfig"
      :tableConfig="tableConfig"
    ></xrk-table>
  </div>
</template>

<script lang="tsx" setup>
import { ref, computed, withDefaults, defineProps } from 'vue';
import {
  XrkTable,
  XrkTableProps,
  useTableColumn,
  XrkTableRef,
  BaseImage,
  BaseButton
} from 'xrk-components';
import { getSimilarTaskDetail } from '../data-source/apis';
import { formatter } from '@/utils';
import { useProjectDetailStore } from '@/views/project-center-edit/src/store';
import { useTaskAudit } from '../hooks/useTaskAudit';
import { PLATFORM_AUDIT_STATUS } from '../constants';
const store = useProjectDetailStore();
const projectInfo = computed(() => store.baseData.projectInfo);
const xrkTableRef = ref<XrkTableRef>();

const props = withDefaults(
  defineProps<{
    projectId: number;
    taskId: number;
    similarTaskIdList: number[];
  }>(),
  {}
);

// 搜索项
const searchConfig = ref<XrkTableProps['searchConfig']>({
  searchBtn: {
    show: false,
    text: '搜索'
  },
  resetBtn: {
    show: false,
    text: '重置'
  },
  searchColumns: []
});

const onRefreshTabel = () => {
  xrkTableRef.value?.initCurrentList();
};

// 列表
const tableConfig = ref<XrkTableProps['tableConfig']>({
  tableColumns: [
    useTableColumn({
      label: '提交时间',
      prop: 'createAt',
      formatter: ({ cellValue }) => formatter.date(cellValue)
    }),
    useTableColumn({
      label: '项目参与人',
      prop: 'userName'
    }),
    useTableColumn({
      label: '任务编码',
      prop: 'taskCode'
    }),
    useTableColumn({
      label: '重复图片',
      prop: 'imageList',
      showOverflowTooltip: false,
      render({ cellValue }) {
        return (
          <>
            {cellValue.map(item => {
              return (
                <BaseImage
                  previewTeleported={true}
                  style="width: 100px;height: 100px;margin-right:5px"
                  src={item}
                  preview-src-list={cellValue}
                ></BaseImage>
              );
            })}
          </>
        );
      }
    }),
    useTableColumn({
      label: '服务商状态',
      prop: 'aspAuditStatus',
      formatter: ({ cellValue }) => PLATFORM_AUDIT_STATUS[cellValue].label
    }),
    useTableColumn({
      label: '平台状态',
      prop: 'platformAuditStatus',
      formatter: ({ cellValue }) => PLATFORM_AUDIT_STATUS[cellValue].label
    }),
    useTableColumn({
      label: '工业状态',
      prop: 'industryAuditStatus',
      formatter: ({ cellValue }) => PLATFORM_AUDIT_STATUS[cellValue].label
    }),
    useTableColumn({
      label: '操作',
      fixed: 'right',
      render: ({ row }) => {
        return (
          <>
            <div>
              <BaseButton
                disabled={row.buttonOnOff === 0 || row.buttonOnOff === 2}
                onClick={() => {
                  useTaskAudit({
                    auditStatus: 2,
                    projectId: props.projectId,
                    queryParams: {
                      sceneType: projectInfo.value.sceneType,
                      taskRecordId: [row.id]
                    },
                    auditOver() {
                      xrkTableRef.value.clearSelectionRows();
                      onRefreshTabel();
                    }
                  });
                }}
                type="text"
              >
                通过
              </BaseButton>
              <BaseButton
                disabled={row.buttonOnOff === 0}
                onClick={() => {
                  useTaskAudit({
                    auditStatus: 3,
                    projectId: props.projectId,
                    queryParams: {
                      sceneType: projectInfo.value.sceneType,
                      taskRecordId: [row.id]
                    },
                    auditOver() {
                      xrkTableRef.value.clearSelectionRows();
                      onRefreshTabel();
                    }
                  });
                }}
                type="text"
              >
                不通过
              </BaseButton>
            </div>
          </>
        );
      }
    })
  ]
});

const getListAjax = async params => {
  const data = await getSimilarTaskDetail({
    ...params,
    taskId: props.taskId,
    projectId: props.projectId,
    similarTaskIdList: props.similarTaskIdList
  });
  return data;
};
</script>
<style lang="scss"></style>
